import { CONFIGURE_TYPES, MATERIAL_FIXED_FIELDS, OPERATORS, SOURCE_ITEMS } from './configConstants'

export const createId = prefix => `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`

export const clone = value => JSON.parse(JSON.stringify(value))

const defaultOption = option => clone(option)

export const createConfiguration = () => defaultOption(CONFIGURE_TYPES[0])

export const createCondition = () => ({
  id: createId('condition'),
  fieldType: defaultOption(SOURCE_ITEMS[0]),
  field: defaultOption(MATERIAL_FIXED_FIELDS[0]),
  operator: defaultOption(OPERATORS[0]),
  value: ''
})

export const createConditionGroup = (conditionCount = 1) => ({
  id: createId('group'),
  match: 'AND',
  joinWithNext: 'AND',
  expanded: true,
  conditions: Array.from({ length: Math.max(conditionCount, 1) }, () => createCondition())
})

const createActionType = type => ({
  id: type,
  name: type,
  value: type
})

export const createAction = (type = 'SET') => ({
  id: createId('action'),
  field: '',
  source: '',
  type: createActionType(type),
  value: ''
})

export const createDefaultRuleLayout = () => ({
  conditionGroups: [createConditionGroup()],
  actions: [createAction()]
})

export const createRule = feature => ({
  id: createId('rule'),
  name: '',
  feature,
  active: true,
  expanded: true,
  configuration: createConfiguration(),
  ...createDefaultRuleLayout(),
  previewExpanded: true
})
